/**
 * @packageDocumentation
 * @module f1/security
 */

export interface Freeze {
  /**
   * Creates a function that always returns a given value
   *
   * @public
   * @function f1.freeze
   * @param u the object to freeze
   * @example
   *
   * ```ts
   * ```
   */
  <V>(u: V): V;
}

/**
 * @see Freeze
 */
export default <V>(u: V): V => Object.freeze(u);
